import { render } from "./RAC_Insight.vue?vue&type=template&id=6cffa389&scoped=true"
import script from "./RAC_Insiht.js?vue&type=script&lang=js"
export * from "./RAC_Insiht.js?vue&type=script&lang=js"

import "./RAC_Insight.vue?vue&type=style&index=0&id=6cffa389&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cffa389"]])

export default __exports__